/// <amd-module name="SuiteCommerce.PagePrinter.EmptyState.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.EmptyState.Configuration", ["require", "exports", "SuiteCommerce.PagePrinter.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EmptyStateConfiguration = /** @class */ (function (_super) {
        __extends(EmptyStateConfiguration, _super);
        function EmptyStateConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(EmptyStateConfiguration, "getContinueShoppingURL", {
            get: function () {
                return this.get('siteSettings.touchpoints.continueshopping') || '/';
            },
            enumerable: true,
            configurable: true
        });
        return EmptyStateConfiguration;
    }(Configuration_1.Configuration));
    exports.EmptyStateConfiguration = EmptyStateConfiguration;
});
